import type { AppointmentTypeBehavior } from "@/hooks/useClinicAppointmentTypes";

export const SUPPORTED_BEHAVIORS: AppointmentTypeBehavior[] = [
  "padrao",
  "retorno",
  "aplicacao",
  "banho_tosa",
];

export const BEHAVIOR_LABEL_KEYS: Record<AppointmentTypeBehavior, string> = {
  padrao: "behaviorPadrao",
  retorno: "behaviorRetorno",
  aplicacao: "behaviorAplicacao",
  banho_tosa: "behaviorBanhoTosa",
};

export const BEHAVIOR_OPTIONS = SUPPORTED_BEHAVIORS.map((value) => ({
  value,
  labelKey: BEHAVIOR_LABEL_KEYS[value],
}));

export const normalizeAllowedBehaviors = (
  types?: Array<string | null> | null,
): AppointmentTypeBehavior[] => {
  if (!types?.length) return [];
  return types.filter((t): t is AppointmentTypeBehavior =>
    typeof t === "string" && SUPPORTED_BEHAVIORS.includes(t as AppointmentTypeBehavior)
  );
};

export const hasRestrictedBehaviors = (
  types?: Array<string | null> | null,
): boolean => normalizeAllowedBehaviors(types).length > 0;

export const isItemAllowedForBehavior = (
  allowedBehaviors: Array<string | null> | null | undefined,
  appointmentBehavior?: string | null,
): boolean => {
  const normalized = normalizeAllowedBehaviors(allowedBehaviors);
  if (normalized.length === 0) return true;
  if (!appointmentBehavior) return false;
  return normalized.includes(appointmentBehavior as AppointmentTypeBehavior);
};
